export { TickIcon } from './tick'
